import React, { useEffect, useState } from "react";
import "./index.less";
import CommodityTable from "./commodityTable";
import { useSelector } from "react-redux";

const Commodities = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    // if (user?.permissions?.departments?.add_edit) {
      setCanUpdate(true);
    // }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Commodity</span>
      <CommodityTable canUpdate={canUpdate} />
    </div>
  );
};

export default Commodities;
